export default import.meta.ROLLDOWN_FILE_URL_hlRuN8fCwC$O1bOmja25ug